// Въпросът „Да продължите ли незавършената …?" на лист, отворен без избор от
// началния екран (директен адрес, таблото, менюто), когато има моя чернова —
// на сървъра или в този браузър (`useDraftResume`). Общият потвърждаващ
// диалог (components/confirm) с два избора-карти — „Продължи черновата"
// (фокусът, Enter) и „Изтрий и започни наново" — и прегледа на редовете ѝ.
// antd слой: клавишите на листа мълчат, докато е отворен; Esc го затваря без
// избор (черновата не се пипа).
import dayjs from "dayjs";
import { FileTextOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "../confirm/ConfirmDialog";
import type { ConfirmPreviewItem } from "../confirm/confirmTypes";
import type { DraftTexts } from "./draftTexts";

type Props = {
  open: boolean;
  texts: DraftTexts;
  // от payload-а на черновата
  savedAt: string | null;
  savedBy: string | null;
  // до 5 реда „Продукт — количество" + общият им брой
  items: ConfirmPreviewItem[];
  total?: number;
  onContinue: () => void;
  onDiscard: () => void;
  // Esc / клик по фона — затваря, без да решава
  onDismiss: () => void;
};

export const DraftResumePrompt = ({
  open,
  texts,
  savedAt,
  savedBy,
  items,
  total,
  onContinue,
  onDiscard,
  onDismiss,
}: Props) => {
  const { t } = useTranslation();
  return (
    <ConfirmDialog
      open={open}
      intent="info"
      icon={<FileTextOutlined />}
      title={savedBy ? t(texts.promptTitleBy, { name: savedBy }) : t(texts.promptTitle)}
      explanation={t("inventoryPage.cfmDraftSavedAt", {
        when: savedAt ? dayjs(savedAt).format("DD.MM.YYYY HH:mm") : "",
      })}
      preview={{ caption: t("inventoryPage.cfmDraftCaption"), items, total }}
      choices={[
        {
          key: "continue",
          label: t("inventoryPage.cfmDraftContinue"),
          hint: t(texts.promptContinueHint),
          primary: true,
          onSelect: onContinue,
        },
        {
          key: "discard",
          label: t("inventoryPage.cfmDraftDiscard"),
          hint: t("inventoryPage.cfmDraftDiscardHint"),
          tone: "danger",
          onSelect: onDiscard,
        },
      ]}
      cancelLabel={t("inventoryPage.close")}
      hideCancel
      onCancel={onDismiss}
    />
  );
};

export default DraftResumePrompt;
